<template>
  <div class="Case">
    <div class="Case_box">
      <ModuleTitle :ModuleTitle="Module_title"></ModuleTitle>

      <div class="Case_box_bottom">
        <div class="Case_box_bottom_left">
          <div class="Case_box_content">
            <div class="name">
              <div class="title active">无贫穷</div>
            </div>
            <div class="info">在世界各地消除一切形式的贫困</div>
          </div>
          <div class="Case_box_content">
            <div class="name">
              <div class="title">清洁饮水和卫生设施</div>
            </div>
            <div class="info">确保人人获得负担得起、可靠、可持续的现代能源</div>
          </div>
          <div class="Case_box_content">
            <div class="name">
              <div class="title">产业、创新和基础设施</div>
            </div>
            <div class="info">确保人人获得负担得起、可靠、可持续的现代能源</div>
          </div>
          <div class="Case_box_content">
            <div class="name">
              <div class="title">优质教育</div>
            </div>
            <div class="info">
              确保包容和公平的优质教育，并为所有人提供终身学习机会
            </div>
          </div>
          <div class="Case_box_content">
            <div class="name">
              <div class="title">气候行动</div>
            </div>
            <div class="info">保护、恢复和促进陆地生态系统的可持续利用</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="Case_box_bottom_right">
          <div class="Case_box_right">
            <div class="Case_box_right_img_box">
            <img src="../../../assets/image/Index/case_img.png" alt="" />
            </div>
            <p>粮农组织：萨赫勒地区“绿色长城”计划投资回报切实可行</p>
            <div>
              联合国粮食及农业组织的一项新研究显示，旨在抗击萨赫勒地区荒漠化问题的非洲“绿色长城”计划不仅能为应对气候变化发挥重要作用，对投资者而言也具备商业价值。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
       Module_title: {name:"Case",more:true}
    };
  },

  components: {
    ModuleTitle: () =>
      import("../../PublicComponents/ModuleTitle/ModuleTitle.vue"),
  },
};
</script>

<style scoped lang="scss">
.Case {
  height: 650px;
  width: 100%;
  background: #fff;
  .Case_box {
    width: 1200px;
    height: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    .Case_box_bottom {
      // background: #ccc;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      //   align-items: flex-start;
      justify-content: space-between;
      .Case_box_bottom_left {
        height: 100%;
        width: 380px;
        .Case_box_content:first-child {
          margin-top: 20px;
        }
        .Case_box_content {
          margin-top: 40px;
          // margin-bottom: 20px;
          .name {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 26px;
            .active{
               color: #0070ff !important;
            }
            .title {
              font-size: 18px;
              height: 26px;
              line-height: 26px;
              font-weight: 600;
              color: #333;
            }
          }
          .info {
            font-size: 14px;
            padding-top: 4px;
            // font-weight: 600;
            color: #d8d8d8;
          }
        }
      }
      .Case_box_bottom_right {
        cursor: pointer;
        width: 780px;
        height: 100%;
        display: flex;
        flex-direction: column;
        &:hover img{
            transition: 0.8s ease;
      transform: scale(1.2, 1.2);
        }
        .Case_box_right {
          width: 100%;
          height: 100%;
          .Case_box_right_img_box{
            margin-top: 20px;
            border-radius: 0 !important;
            width: 780px;
            height: 321px;
            overflow: hidden;
             img {
               transition: 0.8s ease;
               width: 100%;
               height: 100%;
          }
          } 
         
          p {
            margin-top: 24px;
            font-weight: 600;
            height: 25px;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
          }
          div {
            margin-top: 8px;
            background: #ffffff;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
          }
        }
      }
      .line {
        margin-top: 20px;
        width: 1px;
        height: 388px;
        border: 1px solid #e7e7e7;
      }
    }
  }
}
</style>